import { styled } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const VoteIcon = styled(FontAwesomeIcon)`
  margin-right: 5px;
  font-size: 20px;
  color: rgb(255, 81, 96);
`;
